/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

// <a href='https://www.freepik.com/vectors/technology'>Technology vector created by vectorjuice - www.freepik.com</a>
import React, { useContext, useState, useEffect } from 'react';
import moment from 'moment';

// context imports
import { ThemeContext } from '../../contexts/ThemeContext';
import { AuthContext } from '../../contexts/AuthContext';

// local imports
import UnderMaintenanceImg from '../../assets/UnderMaintenance.jpg';

const UnderMaintenance = props => {

    // states
    const [timer, setTimer] = useState({ hours: "00", minutes: "00", seconds: "00" });

    // contexts
    const { theme, fontFamily } = useContext(ThemeContext);
    const { maintenance } = useContext(AuthContext);

    useEffect(() => {
        getTime();
    }, [])

    const getTime = () => {
        setTimeout(() => {
            let remainingTime = moment(maintenance.startAt).add(maintenance.duration, 'minutes').diff(moment(), 'seconds');
            let hours = Math.floor(remainingTime / 3600)
            let minutes = Math.floor((remainingTime % 3600) / 60)
            let seconds = remainingTime % 60
            if (hours < 10) { hours = "0" + hours; }
            if (minutes < 10) { minutes = "0" + minutes; }
            if (seconds < 10) { seconds = "0" + seconds; }
            setTimer({ hours: hours, minutes: minutes, seconds: seconds })
            if (`${hours} : ${minutes} : ${seconds}` !== "00 : 00 : 00")
                getTime();
        }, [1000]);
    }

    return (
        <div className="row p-5" style={{ fontFamily: fontFamily.primary }}>
            <div className="col-md-6 col-12 m-auto" style={{ fontWeight: "600", fontSize: "2rem" }}>
                Umang Wellness is under maintenance.<br />We will be back soon.<br />
                <div className="d-flex">
                    <div style={Object.assign({ backgroundColor: "#91b3fa" }, theme.maintenanceTimer)}>{timer.hours}<div style={theme.maintenanceTimerSubDiv}>hours</div></div>
                    <div style={Object.assign({ backgroundColor: "#91b3fa" }, theme.maintenanceTimer)}>{timer.minutes}<div style={theme.maintenanceTimerSubDiv}>minutes</div></div>
                    <div style={Object.assign({ backgroundColor: "#91b3fa" }, theme.maintenanceTimer)}>{timer.seconds}<div style={theme.maintenanceTimerSubDiv}>seconds</div></div>
                </div>
            </div>
            <img className="col-md-6 col-12 m-auto" src={UnderMaintenanceImg} height="auto" width="80%" />
        </div>
    )

}

export default UnderMaintenance;